import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
const rootElement = document.getElementById("root") as HTMLElement;
const app = (
    <CookiesProvider defaultSetOptions={{ path: "/" }}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </CookiesProvider>
);

// react-snap pre-renders pages at build time; hydrate those instead of re-rendering
if (rootElement.hasChildNodes()) {
    ReactDOM.hydrateRoot(rootElement, app);
} else {
    ReactDOM.createRoot(rootElement).render(app);
}
